import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class AppStateService {
    private _sharedState: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    public readonly sharedState$: Observable<any> = this._sharedState.asObservable();

    constructor() {}

    updateState(newState: any): void {
        this._sharedState.next(newState);
    }

    getCurrentState(): any {
        return this._sharedState.value;
    }
}